import * as Yup from 'yup';

export const initialValues = {
    domainAreas: [{ title: '', description: '' }],
};

export const validationSchema = Yup.object().shape({
    domainAreas: Yup.array().of(
        Yup.object().shape({
            title: Yup.string().required('Requerido'),
            description: Yup.string().required('Requerido'),
        })
    ),
});
